import React, { useRef, useState, useEffect } from "react";
import "./PoppupWIndow.css";
import axios from "axios";

const GoogleSheetPop = ({
  isOpen,
  onClose,
  onSave,
  initialContent,
  url,
  language,
  onLanguageChange
}) => {
  const textAreaRef = useRef(null);

  // 添加 temperature 状态
  const [temperature, setTemperature] = useState(0.8);
  const [currentLanguage, setCurrentLanguage] = useState(language);

  const [Content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setContent(initialContent);
    }
  }, [isOpen, initialContent, url, language]);

  const handleLanguageChange = (e) => {
    setCurrentLanguage(e.target.value);
    if (onLanguageChange) {
      onLanguageChange(e);
    }
  };

  const handleSave = () => {
    let newText = textAreaRef.current ? textAreaRef.current.value : "";

    // 将 content 和 temperature 一起保存
    onSave({
      prompt: { content: newText, temperature: temperature },
      language: currentLanguage
    });

    onClose();
  };

  const refreshPromptData = async () => {
    setLoading(true);
    try {
      const updatedUrl = url.replace(`language=${language}`, `language=${currentLanguage}`);
      const response = await axios.get(updatedUrl);
      if (response.status === 200) {
        setContent(response.data.sheetPrompt);
      } else {
        console.log("Failed to fetch new prompts");
      }
    } catch (error) {
      alert(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>Edit Content</h2>
        <p>Remember to <strong>SAVE</strong> the prompt after making changes.</p>

        <div className="textarea-container">
          <div className="textarea-item">
            <h5>Prompt:</h5>
            <textarea
              ref={textAreaRef}
              value={Content}
              onChange={(e) => setContent(e.target.value)}
              className="edit-textarea"
              rows={10}
              cols={40}
            />
            <label>
              Temperature:
              <input
                type="number"
                step="0.1"
                min="0"
                max="2"
                value={temperature}
                onChange={(e) => setTemperature(parseFloat(e.target.value))}
              />
            </label>
            <label className="setting-item">
                  Language:
                  <select value={currentLanguage} onChange={handleLanguageChange}>
                    <option value="Simplified Chinese">Simplified Chinese</option>
                    <option value="Japanese">Japanese</option>
                    <option value="Traditional Chinese">Traditional Chinese</option>
                    <option value="Arabic">Arabic</option>
                    <option value="Czech">Czech</option>
                    <option value="German">German</option>
                    <option value="Spanish">Spanish</option>
                    <option value="Finnish">Finnish</option>
                    <option value="French">French</option>
                    <option value="Indonesian">Indonesian</option>
                    <option value="Italian">Italian</option>
                    <option value="Dutch">Dutch</option>
                    <option value="Norwegian">Norwegian</option>
                    <option value="Polish">Polish</option>
                    <option value="Portuguese">Portuguese</option>
                    <option value="Romanian">Romanian</option>
                    <option value="Slovak">Slovak</option>
                    <option value="Swedish">Swedish</option>
                    <option value="Vietnamese">Vietnamese</option>
                    <option value="Korean">Korean</option>
                    <option value="Russian">Russian</option>
                  </select>
                </label>
              </div>
            </div>


        <div className="button-group">
          <button onClick={handleSave}>Save</button>
          <button onClick={refreshPromptData} disabled={loading}>
            {loading ? "Fetching..." : "Get Live Prompt"}
          </button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default GoogleSheetPop;
